import { CategoryUnionType, CompanyLinkType } from '@api';
import { AddressFields, ContactFields, FormActions } from '@common';
import { MultiSelectField } from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FreelancerFormSchemaType, useFreelancerForm } from './hooks';

const TRANS_PATH = 'EDIT_COMPANY_LINK_FORM.CATEGORIES_FIELDS';

type EditFreelancerFormPropsType = {
  freelancer?: CompanyLinkType;
  onCancel: () => void;
  companyLinkCategories: CategoryUnionType[];
  handleSubmit: (data: FreelancerFormSchemaType) => void;
};

export const EditFreelancerForm: React.FC<EditFreelancerFormPropsType> = ({
  freelancer,
  onCancel,
  companyLinkCategories,
  handleSubmit,
}) => {
  const { t } = useTranslation('common');

  const form = useFreelancerForm(freelancer);

  const resetAndClose = () => {
    form.reset();
    onCancel();
  };

  const categoriesSelectData = companyLinkCategories.map((category) => ({
    label: t(`COMPANY_LINKS.CATEGORIES.${category}`),
    value: category,
  }));

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(handleSubmit)}
        data-testid="edit-freelancer-form"
      >
        <Stack gap="xl">
          <ContactFields.Root>
            <ContactFields.Phone />
            <ContactFields.Email />
            <ContactFields.Mobile />
          </ContactFields.Root>
          <AddressFields.Root>
            <AddressFields.Street />
            <AddressFields.Addition />
            <AddressFields.Zip />
            <AddressFields.City />
            <AddressFields.Country />
          </AddressFields.Root>
          <MultiSelectField
            fieldName="categories"
            data={categoriesSelectData}
            label={t(`${TRANS_PATH}.CATEGORIES_LABEL`)}
            placeholder={t(`${TRANS_PATH}.CATEGORIES_PLACEHOLDER`)}
            searchable
          />
          <FormActions
            onCancel={resetAndClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
